import TitleTime from './TitleTime';
import LoaderGridTimeTurn from './loading/LoaderGridTimeTurn';
import { TypeGridTimeTurn } from './types/AdmissionType';

export interface TypeTimeTurn {
    doctor_id: number;
    day: string;
    time: string;
    clinic_id: number;
    status: string;
}

export default function GridTimeTurn(props: TypeGridTimeTurn) {
    const { dateTimes, currentTimeTurn, setCurrentTimeTurn } = props;

    function handleSetTurnTimeDay(value: number | null) {
        setCurrentTimeTurn(value);
    }

    return (
        <div className="py-4">
            {dateTimes && dateTimes.length > 0 ? (
                <>
                    <p className="font-semibold text-base pb-2">انتخاب ساعت</p>
                    <div className="place-items-center flex flex-wrap justify-center gap-x-3 !gap-y-3 sm:!gap-y-3">
                        {dateTimes.map((item, i) => (
                            <TitleTime
                                key={i}
                                funHnaleder={handleSetTurnTimeDay}
                                currentValue={currentTimeTurn}
                                value={i}
                                data={item}
                            />
                        ))}
                    </div>
                </>
            ) : (
                <LoaderGridTimeTurn />
            )}
        </div>
    );
}
